import AbstractField from "./AbstractField";

export default class SelectField extends AbstractField {
    isInputField = true;
    labelText = '';
    options = [];
    changeAction = null;

    label(text, fancy = false) {
        this.labelText = text;
        this.fancyLabel = fancy;
        return this;
    }

    setOptions(func) {
        this.optionsFunction = func;
        return this;
    }

    onChange(action, ...args) {
        this.changeAction = action;
        this.changeArgs = args;
        return this;
    }

    populate(element) {
        this.populateOptions();
        this.populateFunction(element, this.selectElement);
    }

    populateOptions() {
        this.selectElement.elt.innerHTML = '';
        this.optionsFunction().forEach(({ value, label }) => {
            let option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            this.selectElement.elt.appendChild(option);
        });
    }

    make() {
        this.field = this.p.createDiv();
        let label = this.fancyLabel
            ? this.p.createElement('h3', this.labelText).style('margin', '0')
            : this.p.createDiv(this.labelText);
        label.parent(this.field)
            .class('input-label');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.applyClasses();
        this.applyStyles();

        this.selectElement = this.p.createElement('select')
            .parent(this.field)
            .class('input-text');
        this.selectElement.elt.onchange = () => this.handleChange();

        this.initialized = true;
        return this;
    }

    handleChange() {
        if (!this.changeAction) return;
        let value = this.selectElement.value();
        this.actions.execute(this.changeAction, this.element, ...this.changeArgs.map(
            arg => typeof arg === 'function' ? arg(value) : arg
        ));
    }

    value(val) {
        if (val === undefined) return this.selectElement.elt.value;
        this.selectElement.elt.value = val;
        return this;
    }

    reset() {
        this.selectElement.elt.innerHTML = '';
    }
}
